// Seed sample — "Margaret Henderson" 78 y/o female, Parkinson's + arthritis.
// Mirrors the real F-11133 / F-11136 / F-11134 field structure.
export const MARGARET_SAMPLE = {
  agency: {
    name: "Northwoods Home Care LLC",
    provider_number: "WI-0012345",
    npi: "1306755812",
    address: "415 State St, Madison, WI 53703",
    phone: "608-555-0142",
    fax: "608-555-0143",
    contact_name: "Dana Olson, Agency Director",
  },
  client: {
    first_name: "Margaret",
    last_name: "Henderson",
    middle_initial: "A",
    date_of_birth: "1947-03-22",
    gender: "Female",
    ssn_last4: "6789",
    race: "White / Non-Hispanic",
    language_preferred: "English",
    marital_status: "Widowed",
    address_street: "229 Willow Creek Rd",
    address_city: "Verona",
    address_state: "WI",
    address_zip: "53593",
    county_of_residence: "Dane",
    county_of_responsibility: "Dane",
    phone_primary: "608-555-0211",
    phone_work: "",
    phone_cell: "608-555-0299",
    emergency_contact: "Claire Henderson (daughter)",
    emergency_phone: "608-555-0312",
    legal_rep: "Self",
    insurance_type: "Medicaid",
    forwardhealth_member_id: "1234567890",
    mco_name: "iCare Family Care Partnership",
    mco_member_id: "",
    medical_record_number: "MH-44821",
    assessment_date: "2026-02-04",
    assessment_location: "Client home — Verona, WI",
    living_situation: "own_alone",
    living_situation_other: "",
  },
  insurance: {
    types: ["forwardhealth"],
    medicaid_number: "1234567890",
    ltc_number: "",
    railroad_number: "",
    other_name: "",
    other_policy: "",
  },
  responsible_party: {
    relationship: "Adult Child",
    name: "Claire Henderson",
    phone_home: "608-555-0312",
    phone_work: "",
    phone_cell: "608-555-0388",
    best_time: "Evenings after 5pm",
    address: "12 Oak Lane, Madison, WI 53711",
  },
  physician: {
    name: "Dr. Aisha Patel, MD",
    npi: "1427365091",
    address: "Meriter Clinic, 202 S. Park St, Madison, WI 53715",
    phone: "608-555-0444",
    fax: "608-555-0445",
  },
  skilled_visits: ["RN"],
  adl: {
    bathing: { pcst_level: "D", score: "3", days_per_week: "7", frequency: "Daily", assistance_type: "Hands-on assist", notes: "Bath bench; tremor limits reach." },
    dressing: { pcst_level: "D", score: "3", days_per_week: "7", frequency: "Daily", assistance_type: "Set-up + cueing", notes: "Needs help with buttons & socks." },
    dressing_upper: { pcst_level: "D", days_per_week: "7", time_of_day: "am" },
    dressing_lower: { pcst_level: "D", days_per_week: "7", time_of_day: "am" },
    grooming: { pcst_level: "D", days_per_week: "7", time_of_day: "am" },
    eating: { pcst_level: "C", score: "2", days_per_week: "7", meals: ["breakfast", "lunch", "dinner"], days_breakfast: "7", days_lunch: "5", days_dinner: "6", notes: "Adaptive utensils; independent feeder." },
    mobility: { pcst_level: "D", score: "3", days_per_week: "7", notes: "History of 2 falls last 12 mo." },
    toileting: { pcst_level: "D", score: "3", days_per_week: "7", frequency_per_day: "5", notes: "Urgency; needs pathway clear." },
    transferring: { pcst_level: "D", score: "3", days_per_week: "7", notes: "Freezing episodes on rise." },
    prosthetics: { needed: "No", days_per_week: "0", items: "" },
  },
  iadl: {
    meal_prep: { score: "4", notes: "Unable — PCW prepares all meals." },
    housekeeping: { score: "4", notes: "Unable — PCW light housekeeping." },
    laundry: { score: "4", notes: "Unable — PCW assists." },
    shopping: { score: "4", notes: "Daughter shops weekly." },
    medication_mgmt: { score: "3", notes: "RN fills weekly planner; PCW reminders." },
    money_mgmt: { score: "2", notes: "Daughter POA-finance." },
    phone_use: { score: "1", notes: "Independent with large-button phone." },
    transportation: { score: "4", notes: "Non-driving; paratransit for appts." },
  },
  nursing: {
    medications_admin: "RN pre-pours weekly medi-planner; PCW cues at set times.",
    injectables: "None currently.",
    wound_care: "None.",
    catheter_care: "None.",
    ostomy_care: "None.",
    delegated_acts: ["Medication set-up (RN)", "Blood pressure monitoring (delegated)"],
    incidental: ["Light housekeeping", "Meal preparation", "Laundry"],
    notes: "RN supervisory visit every 62 days per DHS 107.112.",
    medication_assistance: { level: "D", frequency_per_day: "3", days_per_week: "7" },
    part_ii: {
      glucometer: { selected: false },
      skin_care: { selected: false },
      catheter: { selected: false },
      feeding_tube: { selected: false },
      complex_position: { selected: false },
    },
    part_iii: {
      vitals: { selected: true, frequency_per_day: "1", days_per_week: "7" },
      comments: "Blood pressure parameters and hold orders specified on POC.",
    },
  },
  communication: {
    communication: "Verbal, clear; occasional soft voice due to PD.",
    capability_code: "1",
    orientation: "Oriented x3",
    cognition: "Mild short-term memory loss; no dementia dx.",
    vision: "Corrected with bifocals.",
    hearing: "Adequate; hearing aid L ear.",
    speech: "Slow, soft; intelligible.",
    behavior: "Pleasant, cooperative. Denies depression.",
  },
  hearing_aid: { wears_aid: "Yes", ability_code: "2" },
  vision_correction: { wears_lenses: "Yes", ability_code: "1" },
  orientation: { level: "oriented", forgetfulness: ["time", "medications"], disorientation: [] },
  medical_history: {
    chief_complaint: "Functional decline secondary to Parkinson's disease with bilateral OA; needs ADL/IADL support to remain safely at home.",
    past_history: "Parkinson's disease (2018), Osteoarthritis (bilateral knees), HTN, Hyperlipidemia, Osteopenia.",
    surgical_history: "Right total knee arthroplasty (2016). Cholecystectomy (1998).",
    allergies: "Sulfa drugs (rash). NKDA otherwise.",
    hospitalizations: "Fall with contusions, ED 08/2025 (discharged home, no fx).",
    falls: "2 falls in past 12 mo — both in bathroom. Grab bars installed 09/2025.",
    pain: "Knee pain 3-4/10 with ambulation; managed with PRN acetaminophen.",
  },
  diagnoses: [
    { icd10: "G20", description: "Parkinson's disease", date: "2018-05" },
    { icd10: "M17.0", description: "Bilateral primary osteoarthritis of knee", date: "2015-08" },
    { icd10: "I10", description: "Essential (primary) hypertension", date: "2005-03" },
    { icd10: "E78.5", description: "Hyperlipidemia, unspecified", date: "2010-11" },
    { icd10: "Z74.09", description: "Other reduced mobility", date: "2022-06" },
  ],
  medications: [
    { name: "Carbidopa-Levodopa 25/100", dose: "1 tablet", frequency: "TID", route: "PO", start_date: "2018-06-01", end_date: "Ongoing", prescriber: "Dr. Patel" },
    { name: "Lisinopril", dose: "10 mg", frequency: "QD", route: "PO", start_date: "2005-04-01", end_date: "Ongoing", prescriber: "Dr. Patel" },
    { name: "Atorvastatin", dose: "20 mg", frequency: "QHS", route: "PO", start_date: "2010-12-01", end_date: "Ongoing", prescriber: "Dr. Patel" },
    { name: "Acetaminophen", dose: "500 mg", frequency: "Q6H PRN pain", route: "PO", start_date: "2022-01-01", end_date: "Ongoing", prescriber: "Dr. Patel" },
    { name: "Vitamin D3", dose: "1000 IU", frequency: "QD", route: "PO", start_date: "2020-01-01", end_date: "Ongoing", prescriber: "Dr. Patel" },
  ],
  social: {
    lives_with: "Lives alone in one-story rental home.",
    caregiver_support: "Daughter Claire (20 min away) visits 2-3x/week; no other family.",
    home_environment: "Clutter reduced; grab bars installed; clear path from bed to bath; night light.",
    transportation: "Non-driver; uses Dane County paratransit for MD appointments.",
    financial: "Fixed Social Security income; Medicaid eligible.",
    engagement: "Attends church virtually; calls family daily.",
    attends_outside_activities: "No",
    outside_days_per_week: "0",
    economic_cultural: "Widowed, lives alone, Medicaid-eligible. Daughter provides informal support. Culturally Lutheran; weekly virtual church. Needs in-home PCW to remain in community.",
  },
  activity_schedule: [
    { time: "09:00", task: "Morning stretching (seated)", mon: true, tue: true, wed: true, thu: true, fri: true, sat: false, sun: false },
    { time: "14:00", task: "Short walk with walker (indoor)", mon: true, tue: false, wed: true, thu: false, fri: true, sat: false, sun: false },
    { time: "19:00", task: "Evening TV / reading", mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: true },
  ],
  staffing_schedule: [
    { time: "08:00", task: "AM care (bathing, dressing, meal prep)", mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: false },
    { time: "12:00", task: "Lunch set-up & med reminder", mon: true, tue: true, wed: true, thu: true, fri: true, sat: false, sun: false },
    { time: "17:00", task: "PM care (evening meal, bedtime prep)", mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: false },
  ],
  // Keyed by official F-11136 row types (not free text)
  f11136_activity_grid: {
    school: {},
    work: {},
    day_program: {},
    other1: { specify: "" },
    other2: { specify: "" },
  },
  f11136_staffing_grid: {
    skilled_nursing: { mon: "q62d RN visit", specify: "RN supervisory" },
    hha: {},
    pcw: {
      mon: "8–12 & 5–8", tue: "8–12 & 5–8", wed: "8–12 & 5–8",
      thu: "8–12 & 5–8", fri: "8–12 & 5–8", sat: "8–12", sun: "",
      specify: "Northwoods PCWs",
    },
    case_sharing: {},
    other: {},
  },
  f11136_other_info: "Client prefers female PCW when possible. Spare apartment key held by daughter for emergency entry.",
  increase_rationale: "Client requires hands-on ADL assist 2x/day due to PD + knee OA and lives alone at high fall risk. Services enable safe community living and avert avoidable SNF placement.",
  behaviors: { present: "No", description: "" },
  rare_condition: { present: "No", description: "" },
  seizures: { present: "No", last_seizure_category: "", type: "", frequency: "", last_date: "", interventions_yn: "No", interventions: "" },
  prn: { requested: "Yes" },
  incidental_services_provided: "Yes",
  pcst_notes: "Client requires ADL assist to remain safely at home; daughter is informal backup. No seizures or behaviors.",
  billing_provider: {
    name: "Northwoods Home Care LLC",
    provider_number: "WI-0012345",
    address: "415 State St, Madison, WI 53703",
    case_sharing: "",
  },
  cms485: {
    start_of_care_date: "2026-02-10",
    cert_period_from: "2026-02-10",
    cert_period_to: "2026-04-10",
    cert_type: "Certification",
    dme_supplies: "Front-wheeled walker, bath bench, grab bars, bedside commode.",
    safety_measures: "Fall precautions, clear pathways, night lighting, grab bars.",
    nutritional_req: "Regular diet; adequate hydration; no restrictions.",
    allergies: "Sulfa drugs.",
    functional_limitations: ["Ambulation", "Endurance", "Other (Parkinsonian tremor)"],
    activities_permitted: ["Up as tolerated", "Partial weight bearing", "Exercises prescribed"],
    mental_status: "Oriented; mild short-term memory loss.",
    prognosis: "Guarded — chronic progressive Parkinson's; stable with supports.",
    orders_treatments: "PC services 14 hrs/week for ADL/IADL assist; RN supervisory visit q62d.",
    rehab_potential: "Fair — maintenance level with PC support.",
    goals_discharge: "Maintain safety at home; avoid falls & hospitalization; reassess at 60 days.",
    nurse_verbal_soc: "Verbal SOC orders received 2026-02-03 from Dr. Patel.",
    hha_received_date: "",
    physician_sign_date: "",
  },
  clinical_summary: {
    weekly_hours: "14",
    visits_per_week: "13",
    auth_period: "60 days",
    rationale: "Client requires hands-on ADL assist 2x/day due to PD + knee OA. Lives alone, high fall risk. Services enable safe community living.",
    risks_if_denied: "Without services, risk of falls, unsafe medication mgmt, nutritional decline, premature SNF placement.",
    reassessment_plan: "RN reassessment at 60 days or sooner if condition changes.",
  },
  rn_checklist: {},
  screener_signature: {
    rn_name: "Sarah Johnson, RN",
    rn_license: "WI-RN-67890",
    rn_date: "2026-02-04",
    qualification: "RN",
    qualification_other: "",
  },
  signatures: {
    rn_name: "", rn_license: "", rn_date: "",
    agency_rep_name: "", agency_rep_title: "", agency_rep_date: "",
    client_name: "", client_sign_date: "",
    pcw_name: "", pcw_sign_date: "",
  },
};

// RN verification checklist — trimmed to essentials the RN must verify in-person.
// Server-side enforcement already covers: dual-signature distinct, meds End Date
// present on F-11136, Field 26/28 verbatim, dates present — so those are NOT here.
export const RN_CHECKLIST_ITEMS = [
  { id: "client_id_verified",    label: "Client ForwardHealth ID verified against ID card (in-person)." },
  { id: "diagnoses_supported",   label: "All diagnoses supported by the medical record." },
  { id: "adl_scored",            label: "All PCST ADLs (Elements 19-26) assigned a letter-coded level." },
  { id: "nursing_delegation",    label: "Delegated nursing acts comply with DHS 107.112." },
  { id: "staffing_grid_complete",label: "F-11136 Element 15 Staffing grid matches the requested weekly hours." },
  { id: "fall_risk_addressed",   label: "Fall risk assessed; mitigations documented." },
  { id: "goals_measurable",      label: "Clinical goals are measurable & time-bound." },
  { id: "care_plan_reviewed",    label: "Client care plan reviewed in-person with client or representative." },
];

export const FIELD_26_TEXT =
  "I certify/recertify that this patient is confined to his/her home and needs intermittent skilled nursing care, physical therapy and/or speech therapy or continues to need occupational therapy. The patient is under my care, and I have authorized the services on this plan of care and will periodically review the plan.";

export const FIELD_28_TEXT =
  "Anyone who misrepresents or falsifies essential information requested by this form may upon conviction be subject to fine and imprisonment under Federal and/or State law.";

export const F11134_ATTESTATION_TEXT =
  "As the authorized representative of the billing provider, I will assure that the supervising RN completes the following tasks before PC services are provided for the claims submitted to ForwardHealth: the physician's signed and dated orders for this member will be obtained, an assessment at the member's place of residence will be conducted, and a POC will be completed for this member.";

// PCST level options keyed by ADL (A-F, A-G, A-H, or 0+A-E per official F-11133)
export const PCST_ADL_LEVELS = {
  bathing: [
    { value: "A", label: "A — Independent (with/without device)" },
    { value: "B", label: "B — Intermittent supervision/cueing" },
    { value: "C", label: "C — Constant supervision + physical step" },
    { value: "D", label: "D — Partial physical assistance" },
    { value: "E", label: "E — Totally bathed by another" },
    { value: "F", label: "F — Age-appropriate (≤5 yrs)" },
  ],
  dressing: [
    { value: "A", label: "A — Independent / clothing laid out" },
    { value: "B", label: "B — Intermittent supervision/cueing" },
    { value: "C", label: "C — Constant supervision + physical step" },
    { value: "D", label: "D — Partial physical assistance" },
    { value: "E", label: "E — Depends entirely on another" },
    { value: "F", label: "F — Age-appropriate (≤5 yrs)" },
  ],
  grooming: [
    { value: "A", label: "A — Independent" },
    { value: "B", label: "B — Intermittent supervision/cueing" },
    { value: "C", label: "C — Constant supervision + physical step" },
    { value: "D", label: "D — Needs physical set-up" },
    { value: "E", label: "E — Partial physical assistance" },
    { value: "F", label: "F — Depends entirely on another" },
    { value: "G", label: "G — Age-appropriate (≤5 yrs)" },
  ],
  eating: [
    { value: "0", label: "0 — Tube-fed / IV nutrition" },
    { value: "A", label: "A — Independent" },
    { value: "B", label: "B — Intermittent supervision/cueing" },
    { value: "C", label: "C — Meal set-up required" },
    { value: "D", label: "D — Constant supervision" },
    { value: "E", label: "E — Choking history/risk" },
    { value: "F", label: "F — Partial feeding" },
    { value: "G", label: "G — Total feeding" },
    { value: "H", label: "H — Age-appropriate (≤3 yrs)" },
  ],
  mobility: [
    { value: "0", label: "0 — Bedfast" },
    { value: "A", label: "A — Independent" },
    { value: "B", label: "B — Intermittent supervision/cueing" },
    { value: "C", label: "C — Constant supervision + physical step" },
    { value: "D", label: "D — Physical help of another" },
    { value: "E", label: "E — Age-appropriate (≤18 mo)" },
  ],
  toileting: [
    { value: "A", label: "A — Independent" },
    { value: "B", label: "B — Intermittent supervision/cueing" },
    { value: "C", label: "C — Constant supervision" },
    { value: "D", label: "D — Physical help to use toilet / change product" },
    { value: "E", label: "E — Incontinence care" },
    { value: "F", label: "F — Empty ostomy / catheter bag" },
    { value: "G", label: "G — Age-appropriate (≤4 yrs)" },
  ],
  transferring: [
    { value: "A", label: "A — Independent" },
    { value: "B", label: "B — Intermittent supervision/cueing" },
    { value: "C", label: "C — Constant supervision" },
    { value: "D", label: "D — Physical help; can participate" },
    { value: "E", label: "E — Constant help; unable to participate" },
    { value: "F", label: "F — Mechanical lift" },
    { value: "G", label: "G — Age-appropriate (≤3 yrs)" },
  ],
};
